import { Component, Input, OnInit, EventEmitter, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-detalle-ventana',
  templateUrl: './detalle-ventana.component.html',
  styleUrls: ['./detalle-ventana.component.scss']
})
export class DetalleVentanaComponent implements OnInit {


    @ViewChild('dt', {static: false}) dt!: any;

    @Input() title: string;
    @Input() columns: Record<string, any>[] = [];
    @Input() items: FormArray;
    @Input() isModulo: boolean = false;
    @Input() filterBy: string;
    @Input() crud: boolean = false;
    @Input() scrollable: boolean = false;
    @Input() scrollHeight: string = '18rem'
    @Input() esNuevo: boolean = true;
    @Input() editando: boolean = false;
    @Input() mostrarIdx: boolean = true;
    @Input() nombre: string = '';
    @Input() filtrar: boolean = false;
    @Input() totalRecords: number;
    @Input() paginator: boolean = true;
    // @Input() scrollHeight: string

    filterText: string = '';
    rowsPerPageOptions = [10, 20, 50];


    @Output() onClickRow = new EventEmitter();
    @Output() onBtnSelect = new EventEmitter();
    @Output() onBtnNew = new EventEmitter();
    @Output() onBtnDelete = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
    }

    async onClick( obj: FormGroup, editar?: boolean ) {
        if ( editar ) {
            this.onClickRow.emit( obj );
        }
        if ( !this.isModulo ) {
            this.onClickRow.emit( obj );
        }
    }

    getOptionLabel( options: any[], field: any ) {
        let label = '';
        if ( options ) {
            for (const option of options) {
                if ( String(option.valor) === String(field) ) {
                    label += option.nombre;
                }
            }
        }
        return label;
    }

    
    filterData(target: any, blur?: boolean): void {
        this.dt?.filterGlobal(target?.value, 'contains');
    }


    async btnSelect( obj: Record<string, any> ) {
        this.onBtnSelect.emit( obj );
    }

    async btnNew() {
        this.onBtnNew.emit();
    }

    async btnDelete( obj: FormGroup ) {
        this.onBtnDelete.emit( obj );
    }

    filter( obj: Record<string, any> ) {        
        if ( this.filterBy ) {
            if ( obj.modulo === this.filterBy ) {
                return this.filterObject(obj);
            }
            return false;
        }
        return this.filterObject(obj);
    }

    filterObject(obj: Record<string, any>) {        
        if (this.filterText) {
            if (this.filterText) {
                const filterTextLower = this.filterText.toLowerCase();        
                return Object.values(obj).some(value => {
                    return value != null && value.toString().toLowerCase().includes(filterTextLower);
                });
            }
        }
        return true;
    }
    
    mostrar() {
        return (this.crud && (this.esNuevo || this.editando))
    }

    customSort( ev: any ) {
        ev.data.sort((data1, data2) => {
            let value1 = data1.value;
            let value2 = data2.value;
            let result = null;

            if (value1[ev.field] == null && value2[ev.field] != null) result = -1;
            else if (value1[ev.field] != null && value2[ev.field] == null) result = 1;
            else if (value1[ev.field] == null && value2[ev.field] == null) result = 0;
            else if (typeof value1[ev.field] === 'string' && typeof value2[ev.field] === 'string') result = value1[ev.field].localeCompare(value2[ev.field]);
            else result = value1[ev.field] < value2[ev.field] ? -1 : value1[ev.field] > value2[ev.field] ? 1 : 0;

            return ev.order * result;
        });
    }

}
